<template>
  <div>
    <div
      v-if="startupList == '' || startupList == null"
      class="is-detail-list detail-table mg-y-15"
    >
      <p
        class="has-text-drak is-size-4 th column is-padding-x-s is-margin-top-s has-text-centered"
      ></p>
      <p
        class="has-text-drak is-size-6 th column is-padding-x has-text-centered has-text-centered"
      >
        *** {{ $t("form.notFoundFormData") }} ***
      </p>
      <p
        class="has-text-drak is-size-4 th column is-padding-x-s is-margin-top-s has-text-centered"
      ></p>
    </div>

    <div
      v-else
      class="columns detail-table is-margin-x-not is-vcentered"
      v-for="(data, index) in startupList"
      :key="data.id"
    >
      <div
        v-if="getRule === 'admin'"
        class="column is-1 has-text-centered dp-menu-action is-hidden-tablet"
      >
        <span
          class="icon is-large"
          @click="$emit('goToDetail', data), $emit('setViewComponent', true)"
        >
          <b-tooltip label="view" position="is-bottom" type="is-white">
            <i class="fas fa-eye"></i>
          </b-tooltip>
        </span>
      </div>

      <div
        v-if="getRule === 'staff' && Object.values(formProps).length > 0"
        class="column is-1 has-text-right dp-menu-action is-hidden-tablet"
      >
        <b-dropdown
          :position="
            index < startupList.length - 3 ? 'is-bottom-left' : 'is-top-left'
          "
        >
          <button class="button dp-btn-noBg" slot="trigger">
            <template>
              <b-tooltip
                label="More"
                position="is-bottom"
                type="is-white"
                :delay="500"
              >
                <b-icon
                  pack="fas"
                  icon="sync-alt"
                  custom-class="fa-ellipsis-v label-right"
                  class="has-text-grey-light is-margin-right-m"
                ></b-icon>
              </b-tooltip>
            </template>
          </button>

          <b-dropdown-item
            class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
          >
            <div
              @click="
                $emit('goToDetail', data), $emit('setViewComponent', true)
              "
              class="dp-link"
            >
              <p class="textActive">{{ $t("message.view") }}</p>
            </div>
          </b-dropdown-item>

          <b-dropdown-item
            v-if="data.isLockForm === false"
            class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
          >
            <div
              @click="
                $emit('goToDetail', data), $emit('setViewComponent', false)
              "
              class="dp-link"
            >
              <p class="textActive">{{ $t("message.edit") }}</p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="data.isLockForm === false"
            class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
          >
            <div @click="lockForm(data.startUpId)" class="dp-link">
              <p class="textActive">{{ $t("message.lock") }}</p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="data.isLockForm === true"
            class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
          >
            <div @click="unlockForm(data.startUpId)" class="dp-link">
              <p class="textActive">{{ $t("message.unlock") }}</p>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div
        class="column is-3 has-text-centered-tablet has-text-right"
        data-label="organizeName"
      >
        <div
          v-if="widthMax > 768"
          class="is-align-center is-justify-center is-flex-large is-flex-row"
        >
          <div class="column is-2 has-text-right icon-unflex">
            <div v-show="data.userStatus === 0">
              <b-tooltip
                label="Unverified"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="exclamation-circle"
                  custom-class="exclamation-circle"
                  class="has-color-light-bold"
                ></b-icon>
              </b-tooltip>
            </div>
            <div v-show="data.userStatus === 1">
              <b-tooltip
                label="Wait for Approval"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="exclamation-circle"
                  custom-class="exclamation-circle"
                  class="has-text-warning-yellow"
                ></b-icon>
              </b-tooltip>
            </div>
            <div v-show="data.userStatus === 2">
              <b-tooltip
                label="Verified"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="check-circle"
                  custom-class="check-circle"
                  class="has-text-primary-green"
                ></b-icon>
              </b-tooltip>
            </div>
            <div v-show="data.userStatus === 3">
              <b-tooltip
                label="Suspended"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="ban"
                  custom-class="ban"
                  class="has-text-danger-status"
                ></b-icon>
              </b-tooltip>
            </div>
          </div>
          <div
            class="column is-3 is-2-fullhd has-text-centered-tablet has-text-right"
          >
            <figure class="image box-circle-s is-marginless">
              <img
                class="is-rounded"
                v-if="data.organizeLogo && data.organizeLogo !== ''"
                :src="imgUrl + data.organizeLogo"
              />
              <img
                class="is-rounded"
                v-else
                src="https://bulma.io/images/placeholders/64x64.png"
                alt="Placeholder image"
              />
            </figure>
          </div>
          <div class="column has-text-left is-hidden-mobile">
            <p class="has-text-dark is-size-7 has-text-weight-normal th">
              {{ data.organizeName }}
            </p>
            <p class="is-size-7 has-text-weight-normal th">{{ data.name }}</p>
          </div>
        </div>
        <div
          v-if="widthMax < 768"
          class="is-align-center is-justify-center is-flex is-flex-column"
        >
          <div class="column is-6 has-text-right icon-unflex">
            <div v-show="data.userStatus === 0">
              <b-tooltip
                label="Unverified"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="exclamation-circle"
                  custom-class="exclamation-circle"
                  class="has-text-grey-light"
                ></b-icon>
              </b-tooltip>
            </div>
            <div v-show="data.userStatus === 1">
              <b-tooltip
                label="Wait for Approval"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="exclamation-circle"
                  custom-class="exclamation-circle"
                  class="has-text-warning-yellow"
                ></b-icon>
              </b-tooltip>
            </div>
            <div v-show="data.userStatus === 2">
              <b-tooltip
                label="Verified"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="check-circle"
                  custom-class="check-circle"
                  class="has-text-primary-green"
                ></b-icon>
              </b-tooltip>
            </div>
            <div v-show="data.userStatus === 3">
              <b-tooltip
                label="Suspended"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="ban"
                  custom-class="ban"
                  class="has-text-danger-status"
                ></b-icon>
              </b-tooltip>
            </div>
          </div>
          <div class="column is-6 has-text-centered pd-col-fixed">
            <figure class="image box-circle-s">
              <img
                class="is-rounded"
                v-if="data.organizeLogo"
                :src="imgUrl + data.organizeLogo"
              />
              <img
                class="is-rounded"
                v-else
                src="https://bulma.io/images/placeholders/64x64.png"
                alt="Placeholder image"
              />
            </figure>
          </div>
          <div class="column is-6 has-text-centered pd-col-fixed">
            <p class="has-text-dark is-size-7 has-text-weight-normal th">
              {{ data.organizeName }}
            </p>
            <p class="is-size-7 has-text-weight-normal th">{{ data.name }}</p>
          </div>
        </div>
      </div>
      <div class="column is-2 has-text-centered" data-label="statusActive">
        <b-dropdown v-model="data.statusActive" position="is-bottom-left">
          <button class="button dropdownStatusStartUp min-w-152" slot="trigger">
            <template>
              <b-icon
                v-if="data.statusActive == 1"
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-success"
              ></b-icon>
              <b-icon
                v-if="data.statusActive == 2"
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-info"
              ></b-icon>
              <b-icon
                v-if="data.statusActive == 3"
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-grey-light"
              ></b-icon>
              <b-icon
                v-if="data.statusActive == 4"
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="text-batch"
              ></b-icon>
              <b-icon
                v-if="data.statusActive == 0"
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-grey-light"
              ></b-icon>
              <p
                class="is-size-small"
                v-for="status in statusAccount"
                v-bind:key="status.statusId"
              >
                <span v-if="status.statusId == data.statusActive">{{
                  status.name
                }}</span>
              </p>
              <span class="icon is-small">
                <i
                  class="fas fa-angle-down confirm-text-color"
                  aria-hidden="true"
                ></i>
              </span>
            </template>
          </button>
          <div v-for="status in statusAccount" v-bind:key="status.statusId">
            <b-dropdown-item
              @click="updateStatus(data.startUpId, data.statusActive)"
              :value="status.statusId"
              class="is-align-center is-flex-medium is-flex-row"
            >
              <span v-if="status.statusId == 0" class="icon">
                <i class="fas fa-circle has-text-grey-light"></i>
              </span>
              <span v-if="status.statusId == 1" class="icon">
                <i class="fas fa-circle has-text-success"></i>
              </span>
              <span v-if="status.statusId == 2" class="icon">
                <i class="fas fa-circle has-text-info"></i>
              </span>
              <span v-if="status.statusId == 3" class="icon">
                <i class="fas fa-circle has-text-grey-light"></i>
              </span>
              <span v-if="status.statusId == 4" class="icon">
                <i class="fas fa-circle text-batch"></i>
              </span>
              <p class="textActive">
                {{
                  $i18n.locale === "th"
                    ? status.name
                    : status.nameEN | capitalize
                }}
              </p>
            </b-dropdown-item>
          </div>
        </b-dropdown>
      </div>
      <div class="column has-text-centered" data-label="typeOfIndustry">
        <p class="is-size-7 th">
          {{ getTypeOfIndustry(data.typeOfBusiness) | snippetMid }}
        </p>
      </div>
      <div
        v-if="getRule !== 'staff'"
        class="column has-text-centered"
        data-label="staffId"
      >
        <div class="field">
          <div class="control">
            <button
              @click="openStaffModal(data.startUpId, data.staffs)"
              class="button has-bg-primary has-text-white btnStaff"
              slot="trigger"
            >
              <span class="th" :title="getStaffInCompany(data.staffs)">
                <p>{{ getStaffInCompany(data.staffs) | snippetMobileSmall }}</p>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="column has-text-centered is-hidden-mobile" data-label="form">
        <p v-if="renderCompanyList === false" class="is-size-6 th">
          {{ $t("message.msgLoading") }}...
        </p>
        <p v-else-if="Object.values(formProps).length > 0" class="is-size-6 th">
          {{ getPercenrComplete(data.startUpId) }}%
        </p>
        <p v-else class="notForm th">{{ $t("form.notFound") }}</p>
      </div>
      <div class="column has-text-centered" data-label="registerDate">
        <div class="has-text-centered is-hidden-mobile">
          <p class="is-size-6 has-text-weight-normal">
            {{ dateFomat(data.registerDate) }}
          </p>
        </div>
        <div
          class="is-flex is-justify-spacebetween is-align-center is-hidden-tablet pd-20"
        >
          <div class="has-text-left">
            <p class="is-size-7 has-text-weight-normal">
              {{ dateFomat(data.registerDate) }}
            </p>
          </div>

          <div
            v-if="
              renderCompanyList !== true && Object.values(formProps).length > 0
            "
            class="has-text-right"
            data-label="form"
          >
            <p
              v-if="getPercenrComplete(data.startUpId).length > 0"
              class="is-size-6 th"
            >
              {{ getPercenrComplete(data.startUpId) }}%
            </p>
          </div>
          <p v-else class="notForm th">{{ $t("form.notFound") }}</p>
        </div>
      </div>

      <div class="column is-1 is-vcentered">
        <div class="columns m-h-auto">
          <div class="column has-text-centered is-vcentered">
            <b-icon v-show="data.isLockForm" pack="fas" icon="lock"></b-icon>
          </div>
        </div>
      </div>
      <div
        v-if="getRule === 'admin'"
        class="column is-1 has-text-centered dp-menu-action is-hidden-mobile"
      >
        <span
          class="icon is-large"
          @click="$emit('goToDetail', data), $emit('setViewComponent', true)"
        >
          <b-tooltip label="view" position="is-bottom" type="is-white">
            <i class="fas fa-eye"></i>
          </b-tooltip>
        </span>
      </div>

      <div
        v-if="getRule === 'staff' && Object.values(formProps).length > 0"
        class="column is-1 has-text-right dp-menu-action is-hidden-mobile"
      >
        <b-dropdown
          :position="
            index < startupList.length - 3 ? 'is-bottom-left' : 'is-top-left'
          "
        >
          <button class="button dp-btn-noBg" slot="trigger">
            <template>
              <b-tooltip
                label="More"
                position="is-bottom"
                type="is-white"
                :delay="500"
              >
                <b-icon
                  pack="fas"
                  icon="sync-alt"
                  custom-class="fa-ellipsis-v label-right"
                  class="has-text-grey-light is-margin-right-m"
                ></b-icon>
              </b-tooltip>
            </template>
          </button>

          <b-dropdown-item
            class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
          >
            <div
              @click="
                $emit('goToDetail', data), $emit('setViewComponent', true)
              "
              class="dp-link"
            >
              <p class="textActive">{{ $t("message.view") }}</p>
            </div>
          </b-dropdown-item>

          <b-dropdown-item
            v-if="data.isLockForm === false"
            class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
          >
            <div
              @click="
                $emit('goToDetail', data), $emit('setViewComponent', false)
              "
              class="dp-link"
            >
              <p class="textActive">{{ $t("message.edit") }}</p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="data.isLockForm === false"
            class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
          >
            <div @click="lockForm(data.startUpId)" class="dp-link">
              <p class="textActive">{{ $t("message.lock") }}</p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="data.isLockForm === true"
            class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
          >
            <div @click="unlockForm(data.startUpId)" class="dp-link">
              <p class="textActive">{{ $t("message.unlock") }}</p>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div
      v-if="allList.length > startupList.length && allList.length > 10"
      class="is-margin-top-m has-text-centered"
    >
      <a
        @click="$emit('loadMoreStartupList')"
        class="is-size-7 has-text-weight-semibold is-detail-list"
        >{{ $t("message.btnViewMore") }}</a
      >
    </div>

    <b-modal
      :active.sync="isStaffModal"
      :width="640"
      @close="resetStaff(), (staffDel = [])"
      class="modal-over-unset"
    >
      <div class="card">
        <div class="card-content">
          <div class="content">
            <div class="pd-y-10">
              <span class="is-size-5 has-text-weight-semibold">{{
                $t("message.textStaff")
              }}</span>
              <span class="th is-size-6"> ({{ $t("message.desStaff") }})</span>
            </div>
            <div class="has-text-left">
              <b-field label="" class="th">
                <b-taginput
                  v-model="staffAdd"
                  :data="staffList"
                  autocomplete
                  :open-on-focus="true"
                  field="name"
                  icon="plus"
                  icon-pack="fas"
                  placeholder="Add staff"
                  @typing="getFilteredTags"
                  @add="pushAddStaff"
                  @remove="pushDelStaff"
                >
                  <template slot-scope="props">
                    <p :title="props.option.name + ' ' + props.option.surname">
                      {{ props.option.name }} {{ props.option.surname }}
                    </p>
                  </template>
                  <template slot="empty"> There are no staff </template>
                </b-taginput>
              </b-field>
            </div>
            <div class="pd-y-5">
              <b-button
                @click="(staffAdd = staffListConst), (staffDel = [])"
                type="is-success"
                size="is-small"
                icon-pack="fas"
                icon-left="check"
              >
                {{ $t("message.btnSelectAll") }}
              </b-button>
            </div>
            <div class="is-flex is-flex is-align-end is-justify-end mg-t-10">
              <button
                @click="resetStaff(), (staffDel = [])"
                class="button has-text-grey-dark has-background-grey-lighter mg-5"
                slot="trigger"
              >
                <span class="th">{{ $t("message.btnCancel") }}</span>
              </button>
              <button
                @click="saveUpdateStaff"
                class="button has-text-white is-background-primary mg-5"
                slot="trigger"
              >
                <span class="th">{{ $t("message.btnSave") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "@/axios.js";

export default {
  props: [
    "startupList",
    "allList",
    "batchData",
    "formProps",
    "getPercenrComplete",
    "fetchLoading",
    "renderCompanyList",
    "setViewComponent",
  ],
  data() {
    return {
      widthMax: window.innerWidth,
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      staffList: [],
      staffAdd: [],
      staffDel: [],
      staffListConst: [],
      isStaffModal: false,
    };
  },
  computed: {
    statusAccount() {
      return this.$store.state.statusAccount;
    },
    getRule() {
      return this.$store.getters.getRule;
    },
    businessType() {
      return this.$store.state.businessType;
    },
    batch() {
      return this.$store.state.batch;
    },
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.fetchstaffList();
  },
  methods: {
    getTypeOfIndustry(id) {
      const filter = this.businessType.filter((item) => item.id === id);
      let data = [];
      if (
        filter.length === 0 ||
        typeof filter[0].name === "undefined" ||
        filter[0].name === null ||
        filter[0].name === ""
      ) {
        data = "-";
      } else {
        data = this.$i18n.locale === "th" ? filter[0].name : filter[0].nameEN;
      }
      return data;
    },
    updateStatus(id, status) {
      const data = {
        startUpId: id,
        status: status,
        batchId: this.getRule == "admin" ? this.batchData._id : this.batch._id,
      };
      //console.log("/api/user/update/status/startUp", data);
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post("/api/user/update/status/startUp", data)
        .then((res) => {
          //console.log("/api/user/update/status/startUp", res);
          if (res.data.success) {
            this.$emit("fetchLoading");
            this.emitRealTimeStatusCompany();
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch((e) => {
          console.log("/api/user/update/status/startUp/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    fetchstaffList() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`api/user/get/staff/on/batch/${this.batchData._id}`)
        .then((res) => {
          //console.log('api/user/get/staff/on/batch', res);
          if (res.data.success) {
            this.staffList = res.data.obj.staffs;
            this.staffListConst = res.data.obj.staffs;
          } else {
            this.staffList = [];
          }
        })
        .catch((e) => {
          console.log(
            "api/user/get/status/active/${value}/batch/${this.batch._id}/error",
            e
          );
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    staffName(value) {
      if (typeof this.staffList !== "undefined") {
        const name = this.staffList.filter(
          (result) => result.staffId === value
        );
        if (value == "") {
          var getName = "-";
        } else {
          for (let i = 0; i < name.length; i++) {
            var getName = name[i].name;
          }
        }
        return getName;
      } else {
        return "-";
      }
    },
    dateFomat(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "-";
      } else {
        res = this.$moment(date).format("DD MMMM Y h:mm a");
      }
      return res;
    },
    async lockForm(id) {
      let data = {
        companyId: id,
        batchId: this.batchData._id,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(`api/lock/form/on/batch`, data)
        .then((res) => {
          //console.log("api/lock/form/on/batch", res);

          if (res.data.success) {
            this.$emit("fetchLoading");
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch((e) => {
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
          console.log("api/lock/form/on/batch/error", e);
        });
    },
    async unlockForm(id) {
      let data = {
        companyId: id,
        batchId: this.batchData._id,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(`api/unlock/form/on/batch`, data)
        .then((res) => {
          //console.log("api/unlock/form/on/batch", res);

          if (res.data.success) {
            this.$emit("fetchLoading");
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch((e) => {
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
          console.log("api/lock/form/on/batch/error", e);
        });
    },
    emitRealTimeStatusCompany(id) {
      this.$socket.emit("getStatusStartUp", {
        startUpId: id,
        batchId: this.batch._id,
      });
    },
    async addStaffToCompany() {
      let data = [];
      this.staffAdd.map((item) => {
        data.push({
          batchId: this.batch._id,
          staffId: item.staffId,
          startUpId: this.companyId,
        });
      });

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(`api/batch/assign/staff/to/company`, { data: data })
        .then((res) => {
          if (res.data.success) {
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch((e) => {
          console.log("api/batch/assign/staff/to/company/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
      return "Ok";
    },
    resetStaff() {
      this.$store.commit("setModalActive", false);
      this.isStaffModal = false;
      this.companyId = null;
      this.staffAdd = [];
      this.staffDel = [];
    },
    pushAddStaff(item) {
      let filter = [];

      filter = this.staffAdd.filter(
        (filter) => filter.staffId === item.staffId
      );
      if (filter.length === 0) {
        this.staffAdd.push(item);
      }
    },
    pushDelStaff(item) {
      let filter = [];

      filter = this.staffDel.filter(
        (filter) => filter.staffId === item.staffId
      );
      if (filter.length === 0) {
        this.staffDel.push(item);
      }
    },
    async unassignStaffToCompany() {
      let data = [];
      this.staffDel.map((item) => {
        data.push({
          batchId: this.batch._id,
          staffId: item.staffId,
          startUpId: this.companyId,
        });
      });

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(`api/unassign/staff/from/company`, { data: data })
        .then((res) => {
          if (res.data.success) {
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch((e) => {
          console.log("api/unassign/staff/from/company/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
      return "Ok";
    },
    openStaffModal(id, staff) {
      this.$store.commit("setModalActive", true);
      this.isStaffModal = true;
      this.companyId = id;
      let filterStaff = [];
      staff.map((item) => {
        let resFilter = this.getStaffDetail(item.staffId);
        if (resFilter !== null) {
          filterStaff.push(resFilter);
        }
      });
      this.staffAdd = filterStaff;
    },
    getStaffInCompany(staff) {
      let text = "";
      staff.map((item, index) => {
        let comma = staff.length - 1 !== index ? ", " : "";
        text += item.staff + comma;
      });

      if (text === "") {
        return this.$i18n.locale === "th"
          ? "กรุณาเลือกผู้ดูแล"
          : "Please select staff";
      } else {
        return text;
      }
    },
    async saveUpdateStaff() {
      this.isLoadingPage = true;
      await this.addStaffToCompany();
      await this.unassignStaffToCompany();
      this.emitRealTimeStartupList();
      this.$emit("fetchLoading");
      this.isLoadingPage = false;
      this.resetStaff();
    },
    getFilteredTags(text) {
      this.staffList = this.staffListConst.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >=
            0 ||
          option.surname.toString().toLowerCase().indexOf(text.toLowerCase()) >=
            0
        );
      });
    },
    emitRealTimeStartupList() {
      this.staffAdd.map((item) => {
        this.$socket.emit("listUserInBatch", {
          batchId: this.batch._id,
          staffId: item.staffId,
        });
      });
      this.staffDel.map((item) => {
        this.$socket.emit("listUserInBatch", {
          batchId: this.batch._id,
          staffId: item.staffId,
        });
      });
    },
    getStaffDetail(value) {
      let filter = this.staffList.filter((result) =>
        result.staffId.match(value)
      );
      if (filter.length > 0) {
        return filter[0];
      } else {
        return null;
      }
    },
  },
};
</script>
<style scoped>
.btnStaff {
  width: 100px;
}
</style>
